export default {
  presets: {
    light: {
      primary: '#d43d27',
      secondary: '#666E75',
      success: '#3D9209',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
      backgroundPrimary: '#000',
      backgroundSecondary: '#1B1F22',
      backgroundElement: '#333',
      backgroundBorder: '#DEE5F2',
      textPrimary: '#EEEFFF',
      textInverted: '#FFF',
      shadow: 'rgba(0, 0, 0, 0.12)',
      focus: '#49A8FF',
      transparent: 'rgba(0, 0, 0, 0)',
      backgroundLanding: '#757679',
      backgroundLandingBorder: 'rgba(155, 179, 206, 0.8)',
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
    dark: {
      primary: '#d43d27',
      secondary: '#666E75',
      success: '#3D9209',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
}
